var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',{attrs:{"label":"图片："}},[_c('imageSelect',{attrs:{"url":_vm.tempValue},on:{"update:url":function($event){_vm.tempValue=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }